// extracted by mini-css-extract-plugin
module.exports = {"wrapperInput":"Input_wrapperInput__3AU_v","input":"Input_input__1wuvu","label":"Input_label__qTbIS","error":"Input_error__SHdbV"};